import React from 'react';

const LocalAuthorityTag = ({ status }) => {
    const tagClass = status === 'active' ? 'bg-success' : 'bg-danger';
    const tagText = status === 'active' ? 'Active' : 'Inactive';

    const wrapperStyle = {
        textAlign: 'left',  // Ensure the tag is aligned to the left
        paddingLeft: '5px', // Add some padding to control the sizing/spacing
    };

    return (
        <div style={wrapperStyle}>
            <span className={`badge ${tagClass}`}>{tagText}</span>
        </div>
    );
}

export default LocalAuthorityTag;
